var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-wrapper"},[_c('crud',{key:_vm.reRender,ref:"crud",attrs:{"filterBy":{kind: _vm.kind, filters: _vm.dataFilter},"form-component":_vm.ContractForm,"grid-columns":_vm.gridColumns,"alwaysUpdate":"customerId,typeId,bankId,amount,term,netAmount","grid-options":_vm.gridOptions,"obj":"contract"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb3178b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contracts.vue
// module id = null
// module chunks = 